import store from '@/store'

/**
 * Action 权限指令（Vue3 版）
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <a-button v-action:add>添加用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = {
  // Vue3 指令钩子：Vue2 的 inserted 已废弃，改用 mounted；vnode.context 改为 binding.instance
  mounted(el, binding) {
    const actionName = binding.arg
    const roles = store.getters.roles
    if (!roles || roles.isSuper) {
      return
    }
    const vm = binding.instance
    const elVal = vm && vm.$route && vm.$route.meta ? vm.$route.meta.permission : null
    if (!elVal) {
      return
    }
    const permissionId = elVal instanceof String && [elVal] || elVal
    ;(roles.permissions || []).forEach(p => {
      if (!permissionId.includes(p.permissionId)) {
        return
      }
      // 无权限的话 抹除该元素
      if (p.actionList && !p.actionList.includes(actionName)) {
        el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
      }
    })
  }
}

export default action
